/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep, merge } from 'lodash';

// Components
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';
import CustomActionButton from 'shared/ui/components/form-components/CustomActionButton.vue';

const __vue_script__ = {
    name: 'ModalForm',

    components: {
        MetaForm,
        CustomActionButton
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        fpType: {
            type: String,
            required: true
        },

        onSave: {
            type: Function,
            default: () => {}
        },

        onError: {
            type: Function,
            default: () => {}
        },

        onClose: {
            type: Function,
            default: () => {}
        },

        model: {
            type: Object,
            default: () => ({})
        },

        title: {
            type: String,
            default: null
        },

        docId: {
            type: String,
            default: null
        },

        customActionButtons: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        const buttons = this.customActionButtons || {};
        return {
            customActions: Object.keys(buttons).map(k => ({ _name: k, ...buttons[k] })),
            ready: false,
            innerValue: cloneDeep(this.model),
            fields: [],
            saveHook: 0,
            editing: Boolean(this.model._id || this.docId),
            saving: false
        };
    },

    async created() {
        try {
            if (this.docId) {
                this.innerValue = await this.$services.documents.getDocById(this.event._id, this.docId);
                this.editing = true;
            }

            const metadataForType = await this.$services.metadata.getMetadataForTypeAsArray(this.event._id, this.fpType);
            const processedMetadataFieldsForType = this.$utils.metadata.filterDuplicateTargetsExceptionsFields(metadataForType);
            this.fields = processedMetadataFieldsForType;

            if (!this.model?._id) {
                const defaults = await this.$utils.controls.extractDefaults(this.fields, this.$services);
                this.innerValue = merge(defaults, this.innerValue);
            }

            this.ready = true;
        } catch (error) {
            console.error('[ModalForm] Error while fetching metadata for type %s:', this.fpType, error);
        }
    },

    methods: {
        onSaved(value) {
            this.onSave(value);
            this.saving = false;
            this.close('editor-saved');
        },

        onErrored() {
            this.onError();
            this.saving = false;
        },

        close(reason) {
            if (reason === 'editor-cancel' && !this.editing) {
                reason = 'editor-abort';
            }

            this.onClose(reason, this.model);
            this.$emit('close');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-form modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.close('editor-cancel')}}}),(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('div',{staticClass:"modal-body"},[_c('loader',{staticClass:"in-page",attrs:{"status":!_vm.ready}},[_c('meta-form',{attrs:{"event":_vm.event,"edit":_vm.editing,"fp-type":_vm.fpType,"fields":_vm.fields,"redirect-on-save":false,"save-hook":_vm.saveHook,"value":_vm.innerValue},on:{"saved":_vm.onSaved,"error":_vm.onErrored}})],1)],1),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions",attrs:{"slot":"bottom"},slot:"bottom"},[_c('div',{staticClass:"contextual"},_vm._l((_vm.customActions),function(action){return _c('custom-action-button',{attrs:{"event":_vm.event,"action":action,"context":_vm.innerValue}})}),1),_c('button',{staticClass:"btn default",attrs:{"disabled":_vm.saving},on:{"click":function($event){return _vm.close('editor-cancel')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn primary",attrs:{"disabled":_vm.saving},on:{"click":function($event){_vm.saveHook++; _vm.saving = true}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ModalForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__